/**
 * @description 获取state this.$store.getters对象去访问
 */
const getters = {
  getUserInfo: state => {
    return state.userInfo;
  },
  getNewsCount: state => {
    return state.newsCount;
  },
  getTaskInfo: state => {
    return state.taskInfo;
  },
  getHeadAction: state => {
    return state.headAction;
  },
  getLeftAction: state => {
    return state.leftAction;
  },
  getBehaviorBody: state => {
    return state.behaviorBody;
  },
};

export default getters;
